import { filterTypes } from './mapFilters';

export const serviceTypes = {
  workshop: 'warsztaty',
  summerplay: 'polkolonie',
  academy: 'akademia',
  birthday: 'urodziny',
} as const;

export const services = [
  {
    type: 'service',
    value: serviceTypes.workshop,
    title: 'Warsztaty cykliczne',
    description: 'Zajęcia przez cały rok!',
    disabled: false,
    mapFilters: [
      filterTypes.vacancy,
      filterTypes.firstLesson,
      filterTypes.setDate,
    ],
    highlighted: true,
  },
  {
    type: 'service',
    value: serviceTypes.summerplay,
    title: 'Półkolonie i warsztaty wakacyjne',
    description: 'Turnusy w ferie i wakacje',
    disabled: false,
    mapFilters: [],
  },
  {
    type: 'service',
    value: serviceTypes.birthday,
    title: 'Urodziny',
    description: 'Przyjęcia urodzinowe',
    disabled: false,
    mapFilters: [],
  },
  // {
  //   type: "service",
  //   value: serviceTypes.academy,
  //   title: "Letnia Przygoda w Akademii Robotyki",
  //   description: "5 dni programowania i zabawy w ferie i wakacje",
  //   disabled: false,
  //   mapFilters: [],
  // },
] as const;
